var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('subscription-form',{attrs:{"loading":_vm.loading,"subscriptionData":_vm.subscription,"formErrors":_vm.formErrors},on:{"subscriptionSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }